import React from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";

interface OptionsProps {
  queryString: string;
  variables?: object;
  children?: any;
  dataMapCallback?: Function;
}

interface RenderProps {
  loading?: boolean;
  error?: object;
  data?: object;
}

const ApolloOptionsQuery = ({
  queryString,
  variables,
  dataMapCallback,
  children
}: OptionsProps) => (
  <Query query={gql(queryString)} variables={variables}>
    {(renderProps: RenderProps) => {
      const childrenWithInjectedRenderProps = React.Children.map(
        children,
        child =>
          React.cloneElement(
            child,
            dataMapCallback ? dataMapCallback(renderProps) : dataMapCallback
          )
      );
      return childrenWithInjectedRenderProps;
    }}
  </Query>
);

export default ApolloOptionsQuery;
try {
    // @ts-ignore
    apolloOptionsQuery.displayName = "apolloOptionsQuery";
    // @ts-ignore
    apolloOptionsQuery.__docgenInfo = { "description": "", "displayName": "apolloOptionsQuery", "props": { "queryString": { "defaultValue": null, "description": "", "name": "queryString", "required": true, "type": { "name": "string" } }, "variables": { "defaultValue": null, "description": "", "name": "variables", "required": false, "type": { "name": "object" } }, "dataMapCallback": { "defaultValue": null, "description": "", "name": "dataMapCallback", "required": false, "type": { "name": "Function" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/Apollo/apolloOptionsQuery.tsx#apolloOptionsQuery"] = { docgenInfo: apolloOptionsQuery.__docgenInfo, name: "apolloOptionsQuery", path: "src/shared/hoc/Apollo/apolloOptionsQuery.tsx#apolloOptionsQuery" };
}
catch (__react_docgen_typescript_loader_error) { }